/*LIBRARY*/
import { useEffect, useState, useRef, useCallback } from "react";
import { connect } from "react-redux";
import GeoJsonGeometriesLookup from "geojson-geometries-lookup";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import centroid from "@turf/centroid";

/*COMPONENT*/
import Title from "../form/Title";
import TableOverlay from "../form/TableOverlay";
import NotePembanding from "../data_pembanding/NotePembanding";
import MapComponent from "../universal_form_sub_components/MapComponent";

/*REDUX*/
import {
  get_feature,
  getFieldsPrivate,
  set_value,
} from "../../actions/formActions";
import { set_value_properties } from "../../actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/
import history from "../../actions/history";

/*DATA*/
import dict from "../../validation/dict.json";

/*CONST*/

const Step2 = (props) => {
  // Destructure props
  const {
    auth,
    form,
    properties,
    match,
    set_value: setValue, // Rename to avoid naming conflict/snake_case issues in calls
    set_value_properties: setValueProperties,
    get_feature: getFeature,
    getFieldsPrivate: getFields,
  } = props;

  const {
    geo_layer_wo_geojson,
    fields_section,
    fields_no_section,
    is_location_exist,
  } = form;

  // READ GLOBAL GPS STATUS FROM REDUX
  const { overlay_visibility_status, location_status_gps } = properties;

  // Refs
  // eslint-disable-next-line no-unused-vars
  const geocoderContainerRef = useRef(null);
  // eslint-disable-next-line no-unused-vars
  const mapRef = useRef(null);

  // State
  const [isFullMap, setIsFullMap] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);
  // REMOVED local locationStatus state
  const [accuracy, setAccuracy] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const [userInfo, setUserInfo] = useState({
    full_name: "",
    city: "",
    phone_number_state: "62",
  });

  // Derived variables
  const feature_key = match?.params?.feature_key || "";
  const link = match?.params?.link || "";
  const search = window?.location?.search?.substring(1); // Keep window location usage to match original logic

  // -- METHODS --

  const redirect_step_3_if_not_point = useCallback(() => {
    const { type } = geo_layer_wo_geojson;
    // eslint-disable-next-line
    if (type !== "Point" && type !== "MultiPoint" && type != undefined) {
      history.push(`/${link}/step_3/${feature_key}`);
    }
  }, [geo_layer_wo_geojson, link, feature_key]);

  /**
   * mendapakan geojson feature poligon dimana titik berada
   *
   * mendapatkan nama poligon/nama area/nama administrasi dimana titik berada/dimana gps berada
   */
  const set_polygon_feature = useCallback(
    ({ latitude, longitude }) => {
      const layer_attach = geo_layer_wo_geojson?.layer_form_list?.[0];
      if (
        layer_attach?.type === "Polygon" ||
        layer_attach?.type === "MultiPolygon"
      ) {
        if (layer_attach?.geojson?.features?.length) {
          const fields_polygon = layer_attach?.fields.filter(
            (f) => !f.isStyle && !f.isHide,
          );

          const geojson_polygon = layer_attach?.geojson;
          const geojson_point = {
            type: "Point",
            coordinates: [longitude, latitude],
          };

          const glookup = new GeoJsonGeometriesLookup(geojson_polygon);

          const geojson_polygon_filtered = glookup.getContainers(geojson_point);

          if (geojson_polygon_filtered?.features?.length > 0) {
            setValue("geojson_polygon_filtered", geojson_polygon_filtered);
            setValue("fields_polygon", fields_polygon);
          }
        }
      }
    },
    [geo_layer_wo_geojson, setValue],
  );

  const showPosition = useCallback(
    (position) => {
      const latitude = Number(parseFloat(position.coords.latitude).toFixed(5));
      const longitude = Number(
        parseFloat(position.coords.longitude).toFixed(8),
      );

      setValue("latitude", latitude);
      setValue("longitude", longitude);

      console.log("latitude=", latitude);
      console.log("longitude=", longitude);

      set_polygon_feature({ latitude, longitude });
      setValue("is_location_exist", true);

      //
      const acc = parseInt(position.coords.accuracy);
      setAccuracy(acc);

      // UPDATE GLOBAL REDUX STATE
      setValueProperties({
        key: "location_status_gps",
        value: true,
      });

      setLocationLoading(false);
    },
    [setValue, set_polygon_feature, setValueProperties],
  );

  const onGetLocation = () => {
    setLocationLoading(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      return null;
    }
  };

  const toggle_overlay_visibility_status = () => {
    setValueProperties({
      key: "overlay_visibility_status",
      value: !overlay_visibility_status,
    });
  };

  const handleFullMap = () => {
    setIsFullMap(!isFullMap);
  };

  // eslint-disable-next-line no-unused-vars
  const set_latitude = (value) => {
    if (value >= -90 && value <= 90) {
      setValue("latitude", value);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const set_longitude = (value) => {
    if (value >= -180 && value <= 180) {
      setValue("longitude", value);
    }
  };

  // Helper to handle coordinate logic
  const handleCoordinateLogic = useCallback(() => {
    const features = geo_layer_wo_geojson?.geojson?.features || [];

    if (features.length === 1) {
      const feature = features.find((f) => f.key === feature_key);

      const long = feature?.geometry?.coordinates?.[0];
      const lat = feature?.geometry?.coordinates?.[1];

      if (long && lat) {
        setValue("latitude", lat);
        setValue("longitude", long);
        setValue("is_location_exist", true);
      }
    } else if (geo_layer_wo_geojson?.layer_form_list?.length > 0) {
      const centroid_value = centroid(
        geo_layer_wo_geojson?.layer_form_list?.[0]?.geojson,
      );

      const long = centroid_value?.geometry?.coordinates?.[0];
      const lat = centroid_value?.geometry?.coordinates?.[1];

      setValue("longitude", long);
      setValue("latitude", lat);
      setValue("is_location_exist", true);
    } else {
    }
  }, [geo_layer_wo_geojson, feature_key, setValue]);

  // -- EFFECTS --

  // Component Did Mount equivalent
  useEffect(() => {
    const init = async () => {
      // Logic from componentDidMount
      handleCoordinateLogic();

      let object_param = {};
      let apraisal_id;
      if (search) {
        object_param = JSON.parse(
          '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
          function (key, value) {
            return key === "" ? value : decodeURIComponent(value);
          },
        );

        apraisal_id = object_param?.apraisal_id;
      }

      if (link !== geo_layer_wo_geojson?._id) {
        if (feature_key) {
          const params = {
            geo_layer_link: link,
            feature_key,
            apraisal_id,
            step: "step_2",
          };
          await getFeature(params);
        } else {
          const params = {
            geo_layer_link: link,
            apraisal_id,
          };
          await getFields(params);
        }
      }

      redirect_step_3_if_not_point();
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run once on mount

  // Component Did Update - Auth Listener
  useEffect(() => {
    //kemungkinan update 1: user baru saja login karena user mengakses link dalam kondisi belum login maka akses ulang data
    if (auth.isAuthenticated) {
      // Setting state variables that were in the original class (even if unused in render)
      setUserInfo({
        full_name: auth?.user?.full_name || "",
        city: auth?.user?.city || "",
        phone_number_state: auth?.user?.phone_number || "62",
      });

      if (feature_key) {
        const params = {
          geo_layer_link: link,
          feature_key,
          step: "step_2",
        };
        getFeature(params);
      } else {
        getFields(link);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuthenticated]);

  // Component Did Update - Geo Layer ID change Listener
  useEffect(() => {
    //ada update data yang awalnya tidak ada data kemudian baru saja di load, maka lakukan konversi-konversi dari database ke state yang diperlukan
    if (geo_layer_wo_geojson?._id) {
      handleCoordinateLogic();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geo_layer_wo_geojson?._id]);

  // -- RENDER LOGIC --

  //local storage
  const language = localStorage?.language ? localStorage?.language : "ina";

  /*
    kemungkinan-kemungkinan link step3

    1. `/${geo_layer_wo_geojson?.link}/step_3`
    2. `/${geo_layer_wo_geojson?.link}/step_3?page=0`
    3. `/${geo_layer_wo_geojson?.link}/step_3?page=1`
    4. `/${geo_layer_wo_geojson?.link}/step_3/feature_key`
    5. `/${geo_layer_wo_geojson?.link}/step_3/feature_key?page=0`
    6. `/${geo_layer_wo_geojson?.link}/step_3/feature_key?page=1`
    */

  const item_feature_key = feature_key ? `/${feature_key}` : "";
  let item_page = "";

  if (fields_section.length > 0) {
    if (fields_no_section.length > 0) {
      item_page = "?page=0";
    } else {
      item_page = "?page=1";
    }
  } else {
    item_page = "";
  }

  let search_final = "";

  if (search && search !== undefined) {
    if (item_page) {
      search_final = `&${search}`;
    } else {
      search_final = `?${search}`;
    }
  }

  const link_step_3 =
    `/${geo_layer_wo_geojson?.link}/step_3` +
    item_feature_key +
    item_page +
    search_final;

  const isLocationChangeable = geo_layer_wo_geojson.isLocationChangeable;
  const status = geo_layer_wo_geojson?.formStatus?.status;

  let geolocate_button;

  if (locationLoading) {
    geolocate_button = (
      <div className="button">{dict?.["Mencari"]?.[language]}...</div>
    );
  } else {
    geolocate_button = (
      <div className="button" onClick={onGetLocation}>
        {location_status_gps
          ? dict?.["Perbarui lokasi"]?.[language]
          : dict?.["Aktifkan lokasi"]?.[language]}
      </div>
    );
  }

  /*
    kemungkinan 1
    sudah ada feature_key, langsung lolos apapun kondisinya karena bisa jadi tidak ingin mengedit lokasi titik

    kemungkinan 2
    peta tidak boleh digeser & gps sudah diaktifkan

    kemungkinan 3
    peta boleh digeser & (peta sudah digeser || gps sudah diaktifkan)
    

    kemungkinan lainnya
    disable button
    */

  let button_content;
  const button_enable = (
    <div style={{ textAlign: "center", marginTop: "10px" }}>
      <Link className="button_standard" to={link_step_3}>
        {dict?.["Lanjut"]?.[language]}
      </Link>
    </div>
  );
  const button_disable = (
    <div style={{ textAlign: "center", marginTop: "10px" }}>
      <button className="button_standard" id="grey">
        {dict?.["Lanjut"]?.[language]}
      </button>
    </div>
  );

  if (feature_key) {
    button_content = button_enable;
  } else if (isLocationChangeable && is_location_exist) {
    button_content = button_enable;
  } else if (!isLocationChangeable && location_status_gps) {
    // USED REDUX STATE FOR BUTTON LOGIC
    button_content = button_enable;
  } else {
    button_content = button_disable;
  }

  const content = geo_layer_wo_geojson?._id ? (
    <main>
      <section
        className="container_light"
        id="white_background"
        style={{
          textAlign: "center",
          marginBottom: "10px",
          marginTop: "10px",
        }}
      >
        <table style={{ width: "100%", textAlign: "left" }}>
          <tbody>
            <tr>
              <td>Status</td>
              <td>
                {location_status_gps
                  ? dict?.["lokasi GPS didapatkan"]?.[language]
                  : dict?.["belum klik lokasi"]?.[language]}
              </td>
            </tr>
            <tr>
              <td>{dict?.["Akurasi"]?.[language]}</td>
              <td>
                {location_status_gps && accuracy
                  ? `${accuracy} meter`
                  : dict?.["belum klik lokasi"]?.[language]}
              </td>
            </tr>
          </tbody>
        </table>
        <div className="margin_bottom margin_top">{geolocate_button}</div>
        {geo_layer_wo_geojson?.layer_form_list?.length > 0 && (
          <button className="button" onClick={toggle_overlay_visibility_status}>
            {overlay_visibility_status
              ? dict["Hide overlay data"][language]
              : dict["Show overlay data"][language]}
          </button>
        )}
      </section>

      <TableOverlay />

      <MapComponent
        set_polygon_feature={set_polygon_feature}
        isFullMap={isFullMap}
        handleFullMap={handleFullMap}
        link_step_3={link_step_3}
        // No longer passing locationStatus prop, component uses Redux
      />

      <section style={{ textAlign: "center", marginTop: "10px" }}>
        {isLocationChangeable
          ? dict?.["Administrator survei membolehkan titik digeser manual"]?.[
              language
            ]
          : dict?.[
              "Administrator survei tidak membolehkan titik digeser, tombol lanjut akan muncul jika tombol Aktifkan Lokasi telah ditekan dan pengambilan lokasi GPS diijinkan"
            ]?.[language]}
      </section>

      <section className={isFullMap ? "button_full_map" : ""}>
        {button_content}
      </section>
    </main>
  ) : null;

  return (
    <div className="main_container">
      <Title status={status} step={2} />
      <NotePembanding />
      {content}
      <style>{`.nav_bottom{ display:none;}`}</style>
      <Helmet>
        <title>
          {geo_layer_wo_geojson?.name
            ? geo_layer_wo_geojson?.name
            : "MAPID FORM"}
        </title>
        <meta
          name="description"
          content={
            geo_layer_wo_geojson?.name
              ? geo_layer_wo_geojson?.name
              : "MAPID FORM"
          }
        />
      </Helmet>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  form: state.form,
  properties: state.properties,
  map: state.map,
});

export default connect(mapStateToProps, {
  get_feature,
  set_value,
  getFieldsPrivate,
  set_value_properties,
})(Step2);
